import { render, staticRenderFns } from "./BorrowList.vue?vue&type=template&id=b9251cd8&scoped=true&"
import script from "./BorrowList.vue?vue&type=script&lang=js&"
export * from "./BorrowList.vue?vue&type=script&lang=js&"
import style0 from "./BorrowList.vue?vue&type=style&index=0&id=b9251cd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9251cd8",
  null
  
)

export default component.exports